// tempurpedic UtilityPage content-title bar, rendered in-tree.
//
// The phone is resolved SERVER-SIDE (_content_title_phone): the
// customer_service_phone_number when page.show_customer_service_phone_number,
// else the pre_order_phone_number; href = as_rfc3966, display = as_national.
import React from "react";
import { t } from "ttag";

type IProps = {
    title: string;
    phoneHref: string;
    phoneDisplay: string;
};

export const ContentTitle = (props: IProps): React.JSX.Element => {
    const { title, phoneHref, phoneDisplay } = props;
    return (
        <div className="content-title content-title--orders-page">
            <h1 className="content-title__headline">{title}</h1>
            <span className="content-title__info">
                {t`Have a question about delivery?`}{" "}
                {phoneHref ? <a href={phoneHref}>{phoneDisplay}</a> : null}
            </span>
        </div>
    );
};
